import React, { useContext, useState } from "react";
import {
  convertTo12HourPlusDateFormat,
  formatDate,
  getTimeAgo,
} from "../util/helperFunctions";
import emptyImage from "../images/empty.jpg";
import heartReaction from "../images/reactions/heart-reaction.gif";
import hahaReaction from "../images/reactions/haha-reaction.gif";
import likeReaction from "../images/reactions/like-reaction.gif";
import thanksReaction from "../images/reactions/thanks-reaction.png";
import sadReaction from "../images/reactions/sad-reaction.gif";
import saluteReaction from "../images/reactions/salute-reaction.gif";
import checkReaction from "../images/reactions/check-reaction.gif";

import fireReaction from "../images/reactions/fire-reaction.gif";
import snakeReaction from "../images/reactions/snake-reaction.gif";
import chainReaction from "../images/reactions/chain-reaction.gif";
import dollarReaction from "../images/reactions/dollar-reaction.gif";
import armyReaction from "../images/reactions/Army.gif";
import truckReaction from "../images/reactions/trucking.gif";
import warehouseReaction from "../images/reactions/warehouse.gif";
import moneybagReaction from "../images/reactions/money-bag.gif";
import roosterReaction from "../images/reactions/rooster.gif";
import vesselReaction from "../images/reactions/vessel.gif";

import dragonReaction from "../images/reactions/dragon-reaction.png";
import tigerReaction from "../images/reactions/tiger-reaction.png";
import { ChatContext, WebSocketContext } from "../context/contexts";

function ViewReactionsModal() {
  const Chat = useContext(ChatContext);

  const [reactionViewList, setReactionViewList] = useState(
    Chat.reactionViewList,
  );

  const [expandedUserId, setExpandedUserId] = useState(null);

  const toggleUserReactions = (userId) => {
    setExpandedUserId((prev) => (prev === userId ? null : userId));
  };

  const buildProfileImageSrc = (userProfile) => {
    const profileImage =
      userProfile === "" || userProfile === null
        ? emptyImage
        : `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${userProfile}`;

    return profileImage;
  };

  const buildReactionImage = (reaction) => {
    let reactionImg = emptyImage;
    switch (reaction) {
      case "haha":
        reactionImg = hahaReaction;
        break;
      case "heart":
        reactionImg = heartReaction;
        break;
      case "like":
        reactionImg = likeReaction;
        break;
      case "thanks":
        reactionImg = thanksReaction;
        break;
      case "sad":
        reactionImg = sadReaction;
        break;
      case "salute":
        reactionImg = saluteReaction;
        break;
      case "checked":
        reactionImg = checkReaction;
        break;
      case "fire":
        reactionImg = fireReaction;
        break;
      case "snake":
        reactionImg = snakeReaction;
        break;
      case "chain":
        reactionImg = chainReaction;
        break;
      case "dollar":
        reactionImg = dollarReaction;
        break;
      case "tiger":
        reactionImg = tigerReaction;
        break;
      case "dragon":
        reactionImg = dragonReaction;
        break;
      case "army":
        reactionImg = armyReaction;
        break;
      case "truck":
        reactionImg = truckReaction;
        break;
      case "warehouse":
        reactionImg = warehouseReaction;
        break;
      case "moneybag":
        reactionImg = moneybagReaction;
        break;
      case "rooster":
        reactionImg = roosterReaction;
        break;
      case "vessel":
        reactionImg = vesselReaction;
        break;
    }
    return reactionImg;
  };

  const handleCloseReactionsModal = () => {
    Chat.handleReactionsViewVisible(null);
  };

  const groupedByUser = reactionViewList.reduce((acc, item) => {
    const userId = item.user.id;

    if (!acc[userId]) {
      acc[userId] = {
        user: item.user,
        reactions: [],
      };
    }

    acc[userId].reactions.push({
      reaction_type: item.reaction_type,
      createdAt: item.createdAt,
    });

    return acc;
  }, {});

  return (
    <div className="modal-container">
      <div className="modal-dialog view-reactions-modal-dialog">
        <button className="close-btn" onClick={handleCloseReactionsModal}>
          ✕
        </button>

        <h3>Reactions</h3>

        <div className="modal-content view-reactions-container">
          <div className="view-reactions-list">
            {Object.values(groupedByUser).map((group) => (
              <div className="view-reaction-item" key={group.user.id}>
                {/* USER INFO (secondary) */}
                <div className="view-reaction-user-info">
                  <img
                    src={buildProfileImageSrc(group.user.profile_photo)}
                    alt="profile-photo"
                  />
                  <h4>{group.user.display_name}</h4>
                </div>

                {/* REACTION TIMELINE (primary) */}
                <div className="view-reaction-timeline">
                  {group.reactions.map((reaction, index) => (
                    <div className="reaction-timeline-item" key={index}>
                      <img
                        src={buildReactionImage(reaction.reaction_type)}
                        alt={reaction.reaction_type}
                        className="view-like-reaction"
                      />
                      <span className="reaction-time">
                        {convertTo12HourPlusDateFormat(reaction.createdAt)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewReactionsModal;
